import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "375",
  height: "375",
  viewBox: "0 0 375 375",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M211.949 192.983C217.086 193.474 222.293 193.731 227.561 193.727C254.812 193.706 280.471 186.929 303 175.025C270.951 170.075 237.925 168.288 204.265 170.01C202.577 170.095 200.896 170.197 199.216 170.301C200.888 169.79 202.338 168.58 203.092 166.846C204.345 163.972 203.241 160.672 200.635 159.085C200.265 157.663 199.271 156.417 197.818 155.785C196.372 155.156 194.791 155.272 193.5 155.96C190.532 155.066 187.299 156.51 186.032 159.423C185.168 161.407 185.425 163.593 186.523 165.282C184.761 163.263 182.985 161.253 181.182 159.254C158.591 134.242 133.97 112.156 107.804 93C115.323 117.347 128.678 140.279 147.938 159.56C151.739 163.365 155.689 166.93 159.756 170.277C149.066 162.458 137.143 155.958 124.102 151.139C115.478 147.953 106.745 145.671 98 144.166C109.316 157.855 123.363 169.667 139.936 178.649C151.352 184.835 163.242 189.276 175.301 192.103C159.282 227.841 135.919 257.983 107.804 281.571C123.626 271.441 138.415 259.14 151.692 244.618C165.085 229.965 176.118 213.991 184.826 197.165C195.455 203.8 207.129 209.145 219.724 212.885C237.795 218.248 256.081 219.825 273.761 218.145C266.513 213.026 258.723 208.465 250.371 204.623C237.846 198.858 224.929 195.024 211.949 192.983Z",
  fill: "#E1E0E1",
  "fill-opacity": "0.8"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default render